<a
  [link]="linkUrl"
  [ngClass]="{
    'shadow-S rounded-lg bg-white py-4 px-5': !displayEntityImage,
    'py-4': !displayEntityImage && entityNameSize === 'lg',
    'py-5': !displayEntityImage && entityNameSize === '2xl',
    'py-6': !displayEntityImage && entityNameSize === '3xl',
  }"
  class="flex flex-col block w-full card-link"
>
  @if (displayEntityImage) {
    <div
      class="relative mb-1.5 grow overflow-hidden rounded-lg"
      [class.h-32]="!preserveImageDimensions"
      [class.kiosk:h-full]="!preserveImageDimensions"
      [class.lg:h-44]="!preserveImageDimensions && increaseHeight"
      [ngClass]="{
        'rounded-lg rounded-br-2xxl': templateLayout === themeLayoutKeys.HeroLayout,
        'h-40': !preserveImageDimensions && templateLayout === themeLayoutKeys.HeroLayout,
      }"
      [style.backgroundColor]="imageBackgroundColor | contentBuilderColor: 'neutral-100'"
    >
      @if (imgUrl) {
        <img
          [src]="imgUrl"
          loading="lazy"
          [class.push-shop-card-v2-atom__image]="!preserveImageDimensions"
          [ngClass]="preserveImageDimensions ? 'h-auto w-full' : 'h-full w-full object-cover'"
        />
      }
      @if (closedLabel && imgUrl) {
        <img
          [src]="imgUrl"
          alt=""
          aria-hidden="true"
          class="push-shop-card-v2-atom__closed-veil pointer-events-none absolute inset-0 z-[1]"
          [class.push-shop-card-v2-atom__image]="!preserveImageDimensions"
          [ngClass]="
            preserveImageDimensions ? 'h-full w-full object-fill' : 'h-full w-full object-cover'
          "
        />
      }
      @if (closedLabel && !imgUrl) {
        <div
          class="push-shop-card-v2-atom__closed-fallback pointer-events-none absolute inset-0 z-[1] bg-black opacity-60"
        ></div>
      }
      @if (closedLabel) {
        <div
          class="push-shop-card-v2-atom__closed-label absolute top-0 bottom-0 left-0 right-0 z-10 flex items-center justify-center p-2 font-bold text-center text-white"
          [ngClass]="{
            'pb-10': resolvedCategoryBadge,
            'text-sm xs:text-base': closedLabel.length <= 20,
            'text-2xs xs:text-xs md:text-sm': closedLabel.length > 20,
            'rounded-lg rounded-br-2xxl': templateLayout === themeLayoutKeys.HeroLayout,
          }"
        >
          {{ closedLabel }}
        </div>
      }
      @if (displayEntityCategory && resolvedCategoryBadge) {
        <div class="absolute bottom-0 px-2 py-1 m-2 text-xs font-bold rounded bg-neutral-200">
          {{ resolvedCategoryBadge }}
        </div>
      }
    </div>
  }
  <div>
    @if (displayEntityName) {
      <p
        class="whitespace-pre-line py-0.5 font-accent text-lg font-bold leading-6"
        [class.text-override]="!entityNameColor"
        [class.push-shop-card-v2-atom__entity-name--custom-color]="!!entityNameColor"
        [class.text-neutral-800]="!entityNameColor"
        [style.--shop-card-entity-name-color]="
          entityNameColor ? (entityNameColor | contentBuilderColor) : null
        "
        [ngClass]="{
          'text-xs pb-0.5': entityNameSize === 'xs',
          'text-sm pb-0.5': entityNameSize === 's',
          'text-md pb-0.5': entityNameSize === 'm',
          'text-lg pb-0.5': entityNameSize === 'lg',
          'text-2xl pb-2': entityNameSize === '2xl',
          'text-3xl pb-4': entityNameSize === '3xl',
        }"
      >
        {{ title }}
      </p>
    }
    <p
      class="text-sm font-base"
      [class.text-neutral-600]="!entityMetaColor"
      [style.color]="entityMetaColor ? (entityMetaColor | contentBuilderColor) : null"
    >
      @if (displayEntityDistance && distance) {
        <span class="dot">{{ 'shop-list-header.at' | translate }} {{ formattedDistance }}</span>
      }
      @if (displayEntityPricing && budget) {
        <span class="dot">
          <app-budget-shop-atom
            [value]="budget"
            [currency]="currency"
          ></app-budget-shop-atom>
        </span>
      }
      @if (availableAt) {
        <span class="dot">{{ availableAt }}</span>
      }
      @if (stars) {
        <span class="dot">
          <i class="icon icon-todo mr-0.5 text-xs text-highlight-500"></i>
          <span>{{ stars }}</span>
        </span>
      }
    </p>
    @if (displayEntityAddress && address) {
      <p
        class="text-sm font-base"
        [class.text-neutral-600]="!entityAddressColor"
        [style.color]="entityAddressColor ? (entityAddressColor | contentBuilderColor) : null"
      >
        {{ address }}
      </p>
    }
  </div>
</a>
